import React, { useEffect, useState } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";

const QRScanner = () => {
  const [scanResult, setScanResult] = useState(null);

  useEffect(() => {
    const scanner = new Html5QrcodeScanner("reader", {
      fps: 10,
      qrbox: { width: 250, height: 250 },
    });

    scanner.render(
      (decodedText) => {
        setScanResult(decodedText);
        scanner.clear();
      },
      (error) => {
        console.warn("QR Scan Error:", error);
      }
    );

    return () => scanner.clear();
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="bg-white shadow-lg rounded-lg p-6 w-full max-w-md text-center">
        <h2 className="text-2xl font-semibold mb-4">QR Code Scanner</h2>
        {!scanResult ? (
          <div id="reader" className="w-full h-64 border rounded-lg"></div>
        ) : (
          <div className="mt-4">
            <h3 className="text-lg font-medium text-gray-700">Scanned Result:</h3>
            <p className="text-green-600 font-bold p-2 bg-gray-200 rounded-md mt-2">{scanResult}</p>
            <button
              onClick={() => setScanResult(null)}
              className="mt-4 bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg"
            >
              Scan Again
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default QRScanner;
